// 登录页面
export default {
    rememberPassword: 'Напомнить пароль',
    enterName: 'Пожалуйста, введите имя пользователя',
    enterPassword: 'Пожалуйста, введите пароль',
    forget: 'забыть пароль?',
    login: 'авторизоваться',
    loggingIn: 'Вход в систему',
    userLogin: 'Логин пользователя',
    loginSuccess: 'Вход выполнен успешно',
    VCL: 'Вход с кодом подтверждения',
    PEPN: 'Пожалуйста, введите номер телефона',
    VC: 'Пожалуйста, введите код подтверждения',
    FR: 'зарегистрированный',
    FP: 'забыть пароль',
    GVC: 'получить код подтверждения',
    changePassword: 'Измени пароль',
    tip_PEVC: 'Пожалуйста, введите код подтверждения',
    tip_IVC: 'Неверный код подтверждения',
    tip_MPN: 'Неверный формат номера телефона',
    tip_VCFE: 'Неверный формат кода подтверждения',
    tip_PCYP: 'Пожалуйста, подтвердите свой пароль',
    tip_P: 'Должен содержать прописные и строчные буквы и цифры, могут использоваться специальные символы, а длина - от 8 по 20.',
    tip_TT: 'Два пароля несовместимы!',
    tip_N: 'Китайский, английский, цифры, но без подчеркивания и других символов',
    tip_RS: 'успешно зарегистрироваться',
    tip_PRS: 'Сброс пароля успешно',
    tip_PET: 'Пожалуйста, введите старый пароль',
    tip_PEA: 'Пожалуйста, введите новый пароль',
    tip_PIU: 'Пожалуйста, введите имя пользователя',
    generalUser: 'обычный пользователь',
    businessUser: 'Бизнес-пользователи',
}